export default "__VITE_ASSET__BgR3_0Kn__"